import classNames from "classnames";
import React from "react";
import { NavLink } from "react-router-dom";

export default function ({ text, className, href }) {
  return (
    <React.Fragment>
      {href === undefined ? (
        <h2
          className={classNames("article-title", { [className]: !!className })}
        >
          {text}
        </h2>
      ) : (
        <NavLink
          to={href}
          className={classNames("article-title", "article-title_link", {
            [className]: !!className,
          })}
        >
          <span>{text}</span>
        </NavLink>
      )}
    </React.Fragment>
  );
}
